import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useEffect, useState } from 'react';
import inventoryService from '@root/modules/Warehouse/Inventory/service/inventory';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import product from '@root/modules/Sellers/Product/services/product';

interface DataType {
  key: React.Key;
  ordernumber: string;
  forwardQuan: number;
  updateDate: string;
}

const TableDetailInven = () => {
  const idSell: any = localStorage.getItem('idSeller');
  const [sort, setSort] = useState(true);

  const { inventoryId, productId }: any = useParams();
  const [listOrder, setListOrder] = useState([] as any);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const columns: ColumnsType<DataType> = [
    {
      title: 'Order number',
      dataIndex: 'orderNumber'
    },
    {
      title: 'Forwading Quatity',
      dataIndex: 'orderProducts',
      render: (item) => item[0].orderQuantity
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(true);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => setSort(false)}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];

  /*------get list order---------*/

  const handelPagination = async (
    page: number,

    sort: boolean
  ) => {
    const res = await inventoryService.getDetailTableOrder(
      idSell,
      inventoryId,
      productId,
      page,
      sort
    );
    setTotalPages(res.count);
    const rowData = res.data?.map((row: any) => {
      return {
        ...row,

        updatedAt: formatDateTime(row.updatedAt)
      };
    });

    setListOrder(rowData);
  };

  useEffect(() => {
    handelPagination(page, sort);
  }, [page, sort]);

  return (
    <div>
      {' '}
      <Table
        className="warehouse-table"
        pagination={{
          pageSize: 10,
          current: page,
          total: totalPages,
          onChange: (page, limit) => {
            setPage(page);

            handelPagination(page, sort);
          }
        }}
        columns={columns}
        dataSource={listOrder}
      />
    </div>
  );
};

export default TableDetailInven;
